<template>
  <v-app id="wgu-app" data-app :class="{ 'wgu-app': true, 'wgu-app-embedded': isEmbedded }">

    <slot name="wgu-app-begin" />

    <wgu-app-header>
      <!-- forward the slots of AppHeader -->
      <template v-slot:wgu-tb-start>
        <slot name="wgu-tb-start" />
      </template>
      <template v-slot:wgu-tb-after-title>
        <slot name="wgu-tb-after-title" />
      </template>
      <template v-slot:wgu-tb-before-auto-buttons>
        <slot name="wgu-tb-before-auto-buttons" />
      </template>
      <template v-slot:wgu-tb-after-auto-buttons>
        <slot name="wgu-tb-after-auto-buttons" />
      </template>
      <template v-slot:wgu-tb-end>
        <slot name="wgu-tb-end" />
      </template>
    </wgu-app-header>

    <slot name="wgu-after-header" />

    <wgu-app-sidebar v-if="sidebarWins.length" v-bind="sidebarConfig">
        <template v-for="(moduleWin, index) in sidebarWins">
          <component
            :is="moduleWin.type" :key="index"
            v-bind="moduleWin"
          />
      </template>
    </wgu-app-sidebar>

    <slot name="wgu-before-content" />
    <v-main app>
      <v-container id="ol-map-container" fluid class="fill-height pa-0">
        <wgu-map />
        <!-- layer loading indicator -->
        <wgu-maploading-status />
        <slot name="wgu-after-map" />
        <!-- Portal to overlay the map content from an application module -->
        <portal-target name="map-overlay" />
        <wgu-app-logo />
        <wgu-bglayerswitcher />
        <wgu-overviewmap v-if="overviewMapConfig" v-bind="overviewMapConfig"/>
        <!-- Register custom overlays, e.g. feature hover components here -->
        <tooltip-schutz />
        <tooltip-utiefe />
        <wgu-hover-tooltip />
      </v-container>
    </v-main>

    <template v-for="(moduleWin, index) in floatingWins">
      <component
        :is="moduleWin.type" :key="index"
        v-bind="moduleWin"
      />
    </template>

    <slot name="wgu-before-footer" />

    <wgu-app-footer
      :footerTextLeft="$t('app.footerTextLeft')"
      :footerDatenschutz="$t('app.footerDatenschutz')"
      :footerImpressum="$t('app.footerImpressum')"
      :footerRechtlicheHinweise="$t('app.footerRechtlicheHinweise')"
      :footerBarrierefreiheit="$t('app.footerBarrierefreiheit')"
      :footerTextRight="$t('app.footerTextRight')"
      :showCopyrightYear="showCopyrightYear"
    />

    <slot name="wgu-after-footer" />

    <!-- app wide loading mask,
    use WguEventBus.$emit('app-loading-mask-toggle', newViz) to show/hide -->
    <wgu-app-loading-mask />

    <slot name="wgu-app-end" />

  </v-app>
</template>

<script>
import Vue from 'vue'
import { WguEventBus } from '../src/WguEventBus'
import OlMap from '../src/components/ol/Map'
import HoverTooltip from '../src/components/ol/HoverTooltip'
import AppHeader from './components/AppHeader'
import AppFooter from './components/AppFooter'
import AppSidebar from './components/AppSidebar'
import AppLogo from '../src/components/AppLogo'
import AppLoadingMask from '../src/components/AppLoadingMask'
import BgLayerSwitcher from '../src/components/bglayerswitcher/BgLayerSwitcher.vue'
import OverviewMap from '../src/components/overviewmap/OverviewMap.vue'
import MeasureWin from '../src/components/measuretool/MeasureWin'
import LayerListWin from '../src/components/layerlist/LayerListWin'
import HelpWin from '../src/components/helpwin/HelpWin'
import InfoClickWin from '../src/components/infoclick/InfoClickWin'
import MapLoadingStatus from '../src/components/progress/MapLoadingStatus'
import AttributeTableWin from '../src/components/attributeTable/AttributeTableWin.vue'
import MapRecorderWin from '../src/components/maprecorder/MapRecorderWin'
import SampleModuleWin from './components/SampleModule.vue'

import PrintModuleWin from './PrintModule.vue'
import TooltipSchutz from './TooltipSchutz.vue'
import TooltipUtiefe from './TooltipUtiefe.vue'
import LayerListWinCustom from './components/layerlistcustom/LayerListWinCustom'
import Button3D from './components/3DButton/3DButton.vue'
import InfoButton from './components/InfoButton/InfoButton.vue'
import Impressum from './components/Impressum/Impressum.vue'
import RechtlicheHinweise from './components/RechtlicheHinweise/RechtlicheHinweise.vue'
import Barrierefreiheit from './components/Barrierefreiheit/Barrierefreiheit.vue'
import Datenschutz from './components/Datenschutz/Datenschutz.vue'
import FlyerWindow from './components/FlyerWindow/FlyerWindow.vue'

export default {
  name: 'wgu-app-tpl',
  components: {
    'wgu-map': OlMap,
    'wgu-hover-tooltip': HoverTooltip,
    'wgu-app-header': AppHeader,
    'wgu-app-footer': AppFooter,
    'wgu-app-sidebar': AppSidebar,
    'wgu-app-logo': AppLogo,
    'wgu-app-loading-mask': AppLoadingMask,
    'wgu-bglayerswitcher': BgLayerSwitcher,
    'wgu-overviewmap': OverviewMap,
    'wgu-measuretool-win': MeasureWin,
    'wgu-layerlist-win': LayerListWin,
    'wgu-layerlistcustom-win': LayerListWinCustom,
    'wgu-helpwin-win': HelpWin,
    'wgu-infoclick-win': InfoClickWin,
    'wgu-maploading-status': MapLoadingStatus,
    'wgu-attributetable-win': AttributeTableWin,
    'wgu-maprecorder-win': MapRecorderWin,
    'sample-module-win': SampleModuleWin,
    'print-module-win': PrintModuleWin,
    'wgu-3d-button-win': Button3D,
    'wgu-flyerwindow-win': FlyerWindow,
    'wgu-infobutton-btn': InfoButton,
    'wgu-impressum-win': Impressum,
    'wgu-rechtlichehinweise-win': RechtlicheHinweise,
    'wgu-datenschutz-win': Datenschutz,
    'wgu-barrierefreiheit-win': Barrierefreiheit,
    'tooltip-schutz': TooltipSchutz,
    'tooltip-utiefe': TooltipUtiefe
  },
  data () {
    return {
      isEmbedded: false,
      sidebarConfig: this.getSidebarConfig(),
      overviewMapConfig: this.getOverviewMapConfig(),
      floatingWins: this.getModuleWinData('floating'),
      sidebarWins: this.getModuleWinData('sidebar'),
      showCopyrightYear: Vue.prototype.$appConfig.showCopyrightYear
    }
  },
  created () {
    this.setGlobalAppLang(); // initially set global app language lookup
    this.setDocumentTitle();
  },
  mounted () {
    // apply the isEmbedded state to the member var
    this.isEmbedded = this.$isEmbedded;

    // make the refs (floating module window, which are not connected to their
    // related components, e.g. buttons to toggle them)
    const refs = this.$refs;
    const cmpLookup = {};
    for (const key of Object.keys(refs)) {
      cmpLookup[key] = refs[key][0];
    }
    Vue.prototype.cmpLookup = cmpLookup;
    // inform registered cmps that the app is mounted and the dynamic
    // components are available
    WguEventBus.$emit('app-mounted');

    // load visdom
    // console.log('VISDOM SCRIPT MOUNT int WguAppTemplate');
    const configScript = document.createElement('script');
    configScript.setAttribute('type', 'application/javascript');
    configScript.setAttribute('defer', '');
    configScript.setAttribute('src', './static/libs/visdom/config.js');
    document.head.appendChild(configScript);

    const visdomMainScript = document.createElement('script');
    visdomMainScript.setAttribute('type', 'application/javascript');
    visdomMainScript.setAttribute('defer', '');
    visdomMainScript.setAttribute('src', './static/libs/visdom/main.js');
    document.head.appendChild(visdomMainScript);

    // load visdom style [obsolet?]
    // const visdomMainStyle = document.createElement('link');
    // visdomMainStyle.setAttribute('href', './static/libs/visdom/main.css');
    // visdomMainStyle.setAttribute('rel', 'stylesheet');
    // document.head.appendChild(visdomMainStyle);

    const visdomFontStyle = document.createElement('link');
    visdomFontStyle.setAttribute('href', './static/libs/visdom/fonts.css');
    visdomFontStyle.setAttribute('rel', 'stylesheet');
    document.head.appendChild(visdomFontStyle);
  },
  methods: {
    /**
       * Returns the configuration object for the sidebar from app-config.
       * @return {Object} Sidebar configuration object.
       */
    getSidebarConfig () {
      const appConfig = Vue.prototype.$appConfig || {};

      /* determine from screen size whether to open sidebar or not, overwrites config */

      switch (this.$vuetify.breakpoint.name) {
        case 'xs': appConfig.sidebar.visible = false; break;
        case 'sm': appConfig.sidebar.visible = false; break;
        case 'md': appConfig.sidebar.visible = true; break;
        case 'lg': appConfig.sidebar.visible = true; break;
        case 'xl': appConfig.sidebar.visible = true; break;
      }
      // console.log(this.$vuetify.breakpoint.name);
      // console.log(appConfig.sidebar.visible);

      return appConfig.sidebar;
    },
    /**
       * Returns the configuration object for the overview map from app-config.
       * @return {Object} Overview map configuration object.
       */
    getOverviewMapConfig () {
      const appConfig = Vue.prototype.$appConfig || {};
      return appConfig.overviewMap;
    },
    /**
       * Determines the module window configuration objects from app-config:
       *     moduleWins: [
       *       {type: 'wgu-layerlist-win'},
       *       {type: 'wgu-measuretool-win'}
       *     ]
       * @param  {String} target Either 'floating' or 'sidebar'
       * @return {Array} module window configuration objects
       */
    getModuleWinData (target) {
      const appConfig = Vue.prototype.$appConfig || {};
      const modulesConfs = appConfig.modules || {};
      const moduleWins = [];
      for (const key of Object.keys(modulesConfs)) {
        const moduleOpts = appConfig.modules[key];
        if (moduleOpts.win === target) {
          moduleWins.push({
            type: key + '-win',
            ...moduleOpts
          });
        }
      }
      return moduleWins;
    },
    /**
     * Sets the document title from language file.
     */
    setDocumentTitle () {
      document.title = this.$t('app.browserTitle') || document.title;
    },
    /**
     * Sets the current i18n language to the global app language lookup.
     */
    setGlobalAppLang () {
      Vue.prototype.$appLanguage = this.$i18n.locale;
    }
  },
  watch: {
    /**
     * Watch for locale changes.
     */
    '$i18n.locale': function () {
      this.setGlobalAppLang();
      this.setDocumentTitle();
    }
  }
}
</script>
